import { combineReducers } from '@reduxjs/toolkit'

import { remoteScreenReducer } from '../Features/RemoteScreen/store'
import { fileExplorerReducer } from '../Features/FileExplorer/store'

export const rootReducer = combineReducers({
  remoteScreen: remoteScreenReducer,
  fileExplorer: fileExplorerReducer
})
